module.exports = __webpack_public_path__ + "assets/img/home_bg.fccfbbe5.png";